import {
    MeetingSessionStatus,
    MeetingSessionStatusCode,
} from "amazon-chime-sdk-js";
import { toast } from "react-toastify";
import { state } from "../state";
import { updateDeviceLists } from "./devices";
import { joinRoom } from "./breakout-rooms";
import { API, MEETING_EVENTS_ENDPOINT } from "../../../utils/AxiosInstance";
import { MeetingEvent } from "../types";

export function toggleAudio() {
    if (state.isMuted) {
        state.audioVideo?.realtimeUnmuteLocalAudio();
    } else {
        state.audioVideo?.realtimeMuteLocalAudio();
    }
}

// export function meetingErrorUrl() {
//     return `/meet/error?meeting_id=${state.mainMeetingId}`;
// }

export function audioVideoDidStart() {
     
    console.log("[audioVideoDidStart] Meeting started successfully");
}

async function callEvents(meetingEvents: MeetingEvent[], recorderId?: string) {
    try {
        const { data } = await API.post<{ token: string }>(
            "/meeting_event_tokens",
            { recorder_id: recorderId }
        );
        await fetch(MEETING_EVENTS_ENDPOINT, {
            method: "POST",
            body: JSON.stringify(meetingEvents),

            headers: {
                authorizationToken: data.token,
            },
        });
        localStorage.removeItem("meetingEvents");
        localStorage.removeItem("recorderId");
    } catch  {
        // ignore
    }
}

export function sendEvents(id?: string) {
    const eventStr = localStorage.getItem("meetingEvents");
    const recorderId = id || localStorage.getItem("recorderId");

     
    let meetingEvents: MeetingEvent[] = [];
    if (eventStr) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        meetingEvents = JSON.parse(eventStr);
    }

    if (meetingEvents.length > 0) {
        console.log("sending meeting events");

        setTimeout(() => {
            void callEvents(
                meetingEvents,
                recorderId === null ? undefined : recorderId
            );
        }, 0);
    }
}

export function audioVideoDidStop(sessionStatus: MeetingSessionStatus) {
    const sessionStatusCode = sessionStatus.statusCode();

    if (
        state.recorderId &&
        (sessionStatusCode === MeetingSessionStatusCode.AudioAttendeeRemoved ||
            sessionStatusCode === MeetingSessionStatusCode.MeetingEnded ||
            sessionStatusCode === MeetingSessionStatusCode.NoAttendeePresent ||
            sessionStatusCode === MeetingSessionStatusCode.SignalingBadRequest)
    ) {
        console.log("Closing recorder", state.recorderId);
        sendEvents();
        window.close();
    }

    if (sessionStatusCode === MeetingSessionStatusCode.SignalingBadRequest) {
        // attendee removed
        if (state.isBreakoutRoom) {
            joinRoom(state.mainMeetingId, true);
            return;
        }
    }

    if (sessionStatusCode === MeetingSessionStatusCode.AudioDisconnected) {
         
        console.log("[MeetingManager audioVideoDidStop] Meeting ended for all");
        if (state.isBreakoutRoom) {
            joinRoom(state.mainMeetingId, true);
            return;
        }
    } else if (
        sessionStatusCode ===
        MeetingSessionStatusCode.AudioJoinedFromAnotherDevice
    ) {
        toast.info("Meeting joined from another device.");
    } else if (
        sessionStatusCode === MeetingSessionStatusCode.MeetingEnded &&
        state.isBreakoutRoom
    ) {
        console.log("Breakout room ended.");
        return;
    } else {
         
        console.log(
            `[MeetingManager audioVideoDidStop]session stopped with code ${sessionStatusCode} `
        );
    }
    // window.location.href = meetingErrorUrl();
}

export async function audioInputsChanged(
    freshAudioInputDeviceList?: MediaDeviceInfo[]
) {
    if (!freshAudioInputDeviceList) {
        return;
    }

    const hasSelectedDevice = freshAudioInputDeviceList.some(
        (device) => device.deviceId === state.selectedAudioInputDevice
    );

    let nextInput = "default";
    if (
        state.selectedAudioInputDevice &&
        !hasSelectedDevice &&
        freshAudioInputDeviceList.length
    ) {
        console.info(
            "Previously selected audio input lost. Selecting a default device."
        );
        nextInput = freshAudioInputDeviceList[0].deviceId;

        // Safari and Firefox don't have this "default" as device Id
        // Only Chrome have this "default" device
    } else if (state.selectedAudioInputDevice === "default") {
        console.info(
            `Audio devices updated and "default" device is selected. Reselecting input.`
        );
    }

    try {
        await state.audioVideo?.startAudioInput(nextInput);
        state.selectedAudioInputDevice = nextInput;
        await updateDeviceLists();
    } catch (e) {
         
        console.error(`Error in selecting audio input device`, e);
    }
}
